<div
  class="fixed inset-0 z-50 flex items-center justify-center bg-navy-900/60 backdrop-blur-sm p-4"
  (click)="onBackdropClick($event)"
>
  <div
    class="bg-white rounded-2xl shadow-xl w-full max-w-160 max-h-[90vh] flex flex-col overflow-hidden"
  >
    <!-- Header -->
    <div class="flex items-start justify-between px-8 pt-7 pb-5 shrink-0">
      <div>
        <h2 class="text-base font-bold text-navy-900">{{ title() }}</h2>
        @if (subtitle()) {
          <p class="text-xs text-slate-500 mt-1">{{ subtitle() }}</p>
        }
      </div>
      <button
        (click)="closed.emit()"
        class="w-8 h-8 flex items-center justify-center rounded-full border border-surface-300 hover:bg-surface-100 transition-colors cursor-pointer shrink-0 mt-0.5"
      >
        <img src="/icons/close-icon.svg" class="w-3.5 h-3.5" alt="Close" />
      </button>
    </div>

    <!-- Body -->
    <div class="flex-1 overflow-y-auto px-8 pb-2">
      <ng-content />
    </div>

    <!-- Footer -->
    <div class="px-8 py-7 border-t border-surface-200 shrink-0">
      <ng-content select="[modal-footer]" />
    </div>
  </div>
</div>
